<template>
  <v-container>
    <div>
    <v-card>
      <v-card-text>
        <v-autocomplete
          v-model="model"
          :items="items"
          :loading="isLoading"
          :search-input.sync="search"
          hide-no-data
          hide-selected
          item-text="SearchName"
          item-value="RegId"
          label="Find and select user"
          placeholder="Start typing your name"
          prepend-icon="mdi-database-search"
          return-object
        ></v-autocomplete>
      </v-card-text>

      <v-expansion-panels accordion>
        <v-expansion-panel v-for="(item,i) in 1" :key="i">

          <v-expansion-panel-content>
            <v-list v-if="model" class="green" dense>
              <v-list-item v-for="(field, i) in fields" :key="i">
                <v-list-item-content>
                  <v-list-item-title v-text="field.value"></v-list-item-title>
                  <v-list-item-subtitle v-text="field.key"></v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <v-card-actions>
        <v-spacer></v-spacer>
                      <v-btn icon @click="snackbar = true">
                <v-icon small>fa-info-circle</v-icon>
              </v-btn>
        <v-btn icon :disabled="!model" color="grey darken-3" @click="clear" x-small>
          <v-icon right>mdi-close-circle</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
      <!-- <v-row>
              <v-spacer></v-spacer>
              <v-btn icon @click="snackbar = true">
                <v-icon small>fa-info-circle</v-icon>
              </v-btn>
              <v-spacer></v-spacer>
            </v-row> -->
      
    </v-card>
    <v-snackbar v-model="snackbar">
        {{ snackbartext }}

        <template v-slot:action="{ attrs }">
          <v-btn color="red" text v-bind="attrs" @click="snackbar = false">
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </div>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      descriptionLimit: 60,
      entries: [],
      isLoading: false,
      model: null,
      search: null,
      snackbar: false,
      snackbartext: "If your name does not appear in the list, it's because you have not activated your account.",

    };
  },

  methods: {
      clear () {
          this.model = null;
          this.$emit("selected-regid", this.model);
      }
  },

  computed: {
    fields() {
      if (!this.model) return [];

      return Object.keys(this.model).map(key => {
        // console.log('regId',key)
        console.log("value", this.model[key]);
        this.$emit("selected-regid", this.model[key]);
        return {
          key,
          value: this.model[key] || "n/a"
        };
      });
    },
    items() {
      return this.entries.map(entry => {
        // const Description = entry.SearchName.length > this.descriptionLimit
        //   ? entry.SearchName.slice(0, this.descriptionLimit) + '...'
        //   : entry.SearchName

        // return Object.assign({}, entry, { Description })
        // this.$emit('selected-regid',entry.RegId)
        // console.log(entry.RegId)
        return Object.assign({}, entry);
      });
    }
  },

  watch: {
    // search (val) {
    search() {
      // Items have already been loaded
      if (this.items.length > 0) return;

      // Items have already been requested
      if (this.isLoading) return;

      this.isLoading = true;

      // Lazily load input items
      // https://pgapi.azurewebsites.net/dbapi
      // fetch("http://localhost:3000/dbapi/usersearch")
      fetch("https://pgapi.azurewebsites.net/dbapi/usersearch")
        .then(res => res.json())
        .then(res => {
          //   const { count, entries } = res
          //   this.count = count
          this.entries = res;
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => (this.isLoading = false));
    }
  }
};
</script>